import { create } from "zustand";
import { EventSource } from "@/common/buses";

export interface IEventSource {
  name: EventSource;
  id?: string;
}

export enum SearchInitiator {
  TagLink = "Tag Link",
  SearchInput = "Search Input",
  Other = "Other",
}

interface IAnalyticsState {
  eventSource: IEventSource | null;
  searchInitiator: SearchInitiator | null;
  searchTag: string | null;
  gifContext: string | null;
  setEventSource: (value: IEventSource | null) => void;
  setSearchInitiator: (value: SearchInitiator) => void;
  setSearchTag: (value: string | null) => void;
  setGifContext: (value: string | null) => void;
}

export const useAnalyticsStore = create<IAnalyticsState>((set) => ({
  eventSource: null,
  searchInitiator: null,
  searchTag: null,
  gifContext: null,
  setEventSource: (value) => set(() => ({ eventSource: value })),
  setSearchInitiator: (value: SearchInitiator) => set(() => ({ searchInitiator: value })),
  setSearchTag: (value: string | null) => set(() => ({ searchTag: value })),
  setGifContext: (value: string | null) => set(() => ({ gifContext: value })),
}));
